import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AgeGenderDistribution, AgeGenderDistributionValue } from 'src/app/models/AgeGenderDistribution.model';
import { AgeGenderDistributionData } from './AgeGenderDistributionData.model';
import { ageGenderCompareFunc } from 'src/app/helper/ageGenderCompare';

@Component({
  selector: 'app-age-gender-distribution',
  templateUrl: './age-gender-distribution.component.html',
  styleUrls: ['./age-gender-distribution.component.scss']
})
export class AgeGenderDistributionComponent implements OnInit {
  @Input('form') parentForm: FormGroup;
  @Input('data') data: AgeGenderDistribution;
  @Input('isEditable') isEditable: boolean;
  @Input('isImported') isImported: boolean;
  @Input('isSumDisplayed') isSumDisplayed: boolean;
  @Output() validationCheckOutput = new EventEmitter<boolean>();

  matrix: AgeGenderDistributionData[] = [];
  gridData: GridData = new GridData();
  form: FormGroup;
  lascCtrl;

  constructor(private _formBuilder: FormBuilder) {
  }
  sumText: string = "Sum: ";
  sumNumber: number = 0;
  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('ageGenderDistribution', this._formBuilder.array([]));
    this.form.setControl('ageGenderDistribution', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('ageGenderDistribution').get('values');
    this.data.values = this.lascCtrl.value as AgeGenderDistributionValue[];
    this.gridData = this.ConvertData();
    this.writeSumText();
  }
  asFormGroup(o: AgeGenderDistribution): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  ConvertData(): GridData {
    for (let i = 0; i < this.data.values.length; i++) {
      const element = this.data.values[i];
      let tmpData: AgeGenderDistributionData = new AgeGenderDistributionData();

      tmpData.ageGenderColId = element.ageGenderId + 1;
      if (i < this.data.values.length / 2) {
        tmpData.ageGenderRowId = 1;
      }
      else {
        tmpData.ageGenderRowId = 2;
      }

      if (this.isImported === true) {
        tmpData.value = element.value;
      }
      else {
        tmpData.value = parseFloat((element.value * 100).toFixed(2));
      }
      tmpData.ageGenderGroupName = element.ageGenderGroupName;
      this.matrix.push(tmpData);
    }
    let rowHeaders: IdValue[] = [];
    rowHeaders.push(new IdValue(1, 'Female'));
    rowHeaders.push(new IdValue(2, 'Male'));

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.data.values.length / 2; i++) {
      const headerEntry = this.data.values[i];
      colHeaders.push(new IdValue(headerEntry.ageGenderId + 1, headerEntry.ageGenderGroupName.slice(1, headerEntry.ageGenderGroupName.length)));
    }

    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix;
    grid.colProp = 'ageGenderColId';
    grid.rowProp = 'ageGenderRowId';
    grid.switchColWithRow = false;
    return grid;
  }

  writeSumText() {
    let sum = 0;
    for (let i = 0; i < this.matrix.length; i++) {
      const element = this.matrix[i];
      sum += element.value;
    }
    this.sumNumber = Math.round(sum * 100 + Number.EPSILON) / 100;
    this.validationCheckOutput.emit((this.sumNumber == 100) ? true : false);
  }

  ConvertDataBack(temp: AgeGenderDistributionData[]) {

    let distribution: AgeGenderDistributionValue[] = [];
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      let distr: AgeGenderDistributionValue = new AgeGenderDistributionValue();
      distr.ageGenderGroupName = element.ageGenderGroupName;
      var v = element.value / 100;
      distr.value = Math.round(v * 10000 + Number.EPSILON) / 10000;
      distr.ageGenderId = element.ageGenderColId - 1;
      distribution.push(distr);
    }
    this.data.values = distribution;
  }
  save() {
    this.ConvertDataBack(this.matrix);

    if (this.lascCtrl !== null) {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
  openFile(event) {
    let input = event.target;
    for (var index = 0; index < input.files.length; index++) {
      let reader = new FileReader();
      reader.onload = () => {
        var text = reader.result;
        this.splitText(text.toString());
      }
      reader.readAsText(input.files[index]);
    };
  }
  splitText(text: string) {
    var lines = text.split('\n');
    var valuesAmount;
    for (var index = 0; index < lines.length; index++) {
      var parts = lines[index].split(',');
      for (var index2 = 0; index2 < parts.length; index2++) {
        valuesAmount++;
      }
    }
    this.checkFileContentLength(valuesAmount);
  }

  checkFileContentLength(valuesAmount: number): boolean {
    var lengthMatrix = this.matrix.length;
    if (lengthMatrix !== valuesAmount) {
      return false;
    }
    else {
      return true;
    }
  }
}
